import React, { useState } from 'react';
import { format } from 'date-fns';

// Star rating component
const StarRating = ({ rating }) => {
  const stars = [];
  
  for (let i = 1; i <= 5; i++) {
    if (i <= rating) {
      // Full star
      stars.push(
        <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      );
    } else {
      // Empty star
      stars.push(
        <svg key={i} className="w-4 h-4 text-gray-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      );
    }
  }
  
  return <div className="flex">{stars}</div>;
};

// Source Icon component
const SourceIcon = ({ source }) => {
  switch (source) {
    case 'Google Reviews':
      return (
        <div className="h-6 w-6 rounded-full bg-white p-1">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z" fill="#FFC107" />
            <path d="M3.15295 7.3455L6.43845 9.755C7.32745 7.554 9.48045 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C8.15895 2 4.82795 4.1685 3.15295 7.3455Z" fill="#FF3D00" />
            <path d="M12 22C14.583 22 16.93 21.0115 18.7045 19.404L15.6095 16.785C14.5718 17.5742 13.3038 18.001 12 18C9.39903 18 7.19053 16.3415 6.35853 14.027L3.09753 16.5395C4.75253 19.778 8.11353 22 12 22Z" fill="#4CAF50" />
            <path d="M21.8055 10.0415H21V10H12V14H17.6515C17.2571 15.1082 16.5467 16.0766 15.608 16.7855L15.6095 16.785L18.7045 19.4035C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z" fill="#1976D2" />
          </svg>
        </div>
      );
    case 'App Store':
      return (
        <div className="h-6 w-6 rounded-full bg-white p-1">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM16.5 15.5C16.5 16.1 16.1 16.5 15.5 16.5H8.5C7.9 16.5 7.5 16.1 7.5 15.5V8.5C7.5 7.9 7.9 7.5 8.5 7.5H15.5C16.1 7.5 16.5 7.9 16.5 8.5V15.5Z" fill="#0D96F6"/>
          </svg>
        </div>
      );
    case 'Play Store':
      return (
        <div className="h-6 w-6 rounded-full bg-white p-1">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.18 20.83L12 12l-8.82-8.83C2.7 3.63 2.32 4.28 2 5v14c.32.72.7 1.37 1.18 1.83z" fill="#EA4335"/>
            <path d="M12 12l-8.82 8.83c.48.46 1.03.84 1.66 1.14L16.15 12l-11.31-9.97c-.63.3-1.18.68-1.66 1.14L12 12z" fill="#FBBC04"/>
            <path d="M20.82 12L12 3.17l-7.31 6.39L12 12l-7.31 2.44L12 20.83L20.82 12z" fill="#4285F4"/>
            <path d="M12 12l8.82 8.83c.48-.46.86-1.01 1.16-1.64L13.66 12l8.32-7.19c-.3-.63-.68-1.18-1.16-1.64L12 12z" fill="#34A853"/>
          </svg>
        </div>
      );
    case 'Amazon':
      return (
        <div className="h-6 w-6 rounded-full bg-white p-1">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.3 11.6C14.9 11.2 14.5 11 14.1 11C13.7 11 13.3 11.2 12.9 11.6C12.6 12 12.5 12.3 12.5 12.7C12.5 13.1 12.6 13.4 12.9 13.8C13.2 14.2 13.6 14.4 14 14.4C14.4 14.4 14.8 14.2 15.2 13.8C15.5 13.4 15.7 13.1 15.7 12.7C15.7 12.3 15.6 12 15.3 11.6Z" fill="#FF9900"/>
            <path d="M20.8 17.7C20.4 17.9 18.6 18.9 17.8 19.3C15.3 20.5 12.5 20.5 8.3 18.4C8 18.2 8 18.2 7.5 18C5.3 16.7 3.3 14 3.3 11C3.3 9 4 7.1 5.3 5.5C6.2 4.5 7.2 3.7 8.5 3.1C8.7 3 8.8 3 8.8 3.2C8.8 3.4 8.8 3.6 8.8 4C8.8 4.2 8.7 4.3 8.5 4.4C6.5 5.2 5.4 7.2 5.4 9.5C5.4 12.6 7.5 15.7 10.5 16.8C14.7 18.2 19.5 17 21.1 14.1C22.1 12.2 22.1 9.5 20.8 7.5C19.9 6.2 18.5 5.4 17 5.2C16.7 5.2 16.4 5.1 16.1 5.1C15.8 5.1 15.6 5 15.7 4.6C15.8 4.2 16.4 4 16.7 4C16.8 4 16.9 4 17 4C18.5 4.2 19.8 4.8 20.8 5.8C23.5 8.5 23.5 13 20.7 15.7C20.3 16 19.1 16.8 18.6 17C18.5 17 18.5 17 18.5 17C18.5 17 18.6 16.9 18.8 16.9C19.1 16.8 19.5 16.8 19.8 16.8C20.5 16.8 21.1 16.9 21.8 17.1C22.1 17.2 22.1 17.2 21.8 17.5C21.6 17.6 21.1 17.6 20.8 17.7Z" fill="#FF9900"/>
            <path d="M13.9 8.4C13.9 7.4 13.9 6.5 13.9 5.5C13.9 5.2 14 5.1 14.2 5.1C15.2 5.2 16.2 5.1 17.2 5.2C17.6 5.2 17.9 5.3 18.2 5.6C18.6 6 18.6 6.6 18.3 7C18.1 7.3 17.8 7.5 17.4 7.5C16.7 7.6 16 7.5 15.4 7.5C15.1 7.5 15 7.6 15 7.9C15 8.7 15 9.6 15 10.4C15 10.7 15.1 10.7 15.4 10.7C16.1 10.7 16.8 10.7 17.4 10.7C17.8 10.7 18.1 10.9 18.3 11.3C18.5 11.7 18.4 12.2 18.1 12.5C17.9 12.7 17.5 12.9 17.2 12.9C16.5 12.9 15.9 12.9 15.2 12.9C15 12.9 14.9 13 14.9 13.2C15 13.8 15 14.4 15 14.9C15 15.7 15 15.7 15.8 15.9C17.1 16.1 18.1 16.8 18.4 18C18.8 19.4 18.2 20.8 16.9 21.6C16.5 21.8 16.1 22 15.6 22C14.6 22 13.5 22 12.5 22C12.3 22 12.2 21.9 12.2 21.7C12.2 21.4 12.3 21.2 12.6 21.1C12.8 21 13 21 13.3 20.9C13.9 20.8 14.2 20.4 14.3 19.9C14.4 19.6 14.4 19.3 14.4 19C14.4 18.2 14.4 17.4 14.4 16.6C14.4 16.3 14.3 16.2 14 16.2C13.4 16.2 12.9 16.2 12.3 16.2C12 16.2 11.9 16.1 11.9 15.8C11.9 15.2 11.9 14.6 11.9 14C11.9 13.7 12 13.6 12.3 13.6C12.9 13.6 13.4 13.6 14 13.6C14.3 13.6 14.4 13.5 14.4 13.2C14.3 12.3 14.3 11.4 14.4 10.5C14.4 10.2 14.3 10.1 14 10.1C13.4 10.1 12.9 10.1 12.3 10.1C12 10.1 11.9 10 11.9 9.7C11.9 9.1 11.9 8.5 11.9 7.9C11.9 7.7 12 7.6 12.2 7.5C12.6 7.4 13.1 7.2 13.4 6.8C13.6 6.6 13.8 6.3 13.9 6C13.9 6.8 13.9 7.6 13.9 8.4Z" fill="#FF9900"/>
          </svg>
        </div>
      );
    default:
      return (
        <div className="h-6 w-6 rounded-full bg-gray-200">
          <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
          </svg>
        </div>
      );
  }
};

// Sentiment badge component
const SentimentBadge = ({ sentiment }) => {
  let bgColor = 'bg-gray-100 text-gray-800';
  
  if (sentiment === 'Positive') {
    bgColor = 'bg-green-100 text-green-800';
  } else if (sentiment === 'Negative') {
    bgColor = 'bg-red-100 text-red-800';
  } else if (sentiment === 'Neutral') {
    bgColor = 'bg-blue-100 text-blue-800';
  }
  
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${bgColor}`}>
      {sentiment}
    </span>
  );
};

// Reply status badge component
const ReplyStatusBadge = ({ status }) => {
  const isReplied = status === 'Replied';
  const bgColor = isReplied ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800';
  
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${bgColor}`}>
      {status}
    </span>
  );
};

// Category sentiment tag component
const CategoryTag = ({ category, sentiment }) => {
  let bgColor = 'bg-gray-100 text-gray-800';
  
  if (sentiment === 'Positive') {
    bgColor = 'bg-green-100 text-green-800';
  } else if (sentiment === 'Negative') {
    bgColor = 'bg-red-100 text-red-800';
  } else if (sentiment === 'Neutral') {
    bgColor = 'bg-blue-100 text-blue-800';
  }
  
  return (
    <span className={`inline-flex items-center m-1 px-2 py-1 rounded-md text-xs font-medium ${bgColor}`}>
      {category}
    </span>
  );
};

const ReviewCard = ({ review }) => {
  const [showReply, setShowReply] = useState(false);
  
  // Format date for display
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return format(date, 'MMM d, yyyy');
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4 shadow-sm hover:shadow-md transition-shadow duration-200">
      <div className="flex justify-between items-start mb-3">
        <div className="flex items-center">
          <SourceIcon source={review.source} />
          <div className="ml-2">
            <h3 className="font-medium">{review.userName}</h3>
            <div className="text-xs text-gray-500 flex items-center">
              <span>{formatDate(review.date)}</span>
              <span className="mx-1">•</span>
              <span>{review.region}, {review.city}</span>
            </div>
          </div>
        </div>
        <div className="flex items-center">
          <StarRating rating={review.rating} />
          <div className="ml-2">
            <SentimentBadge sentiment={review.sentiment} />
          </div>
        </div>
      </div>
      
      <div className="mb-3">
        <p className="text-gray-700">{review.reviewText}</p>
      </div>
      
      <div className="flex flex-wrap mb-3">
        {review.categorySentiments.map((cat, index) => (
          <CategoryTag key={index} category={cat.category} sentiment={cat.sentiment} />
        ))}
      </div>
      
      <div className="flex justify-between items-center mt-4 border-t pt-2">
        <div>
          <ReplyStatusBadge status={review.replyStatus} />
        </div>
        <div>
          {review.replyStatus === 'Replied' && (
            <button
              onClick={() => setShowReply(!showReply)}
              className="text-sm text-blue-600 hover:text-blue-800"
            >
              {showReply ? 'Hide Reply' : 'View Reply'}
            </button>
          )}
          {review.replyStatus === 'Not Replied' && (
            <button className="text-sm text-blue-600 hover:text-blue-800 flex items-center">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
              </svg>
              Reply
            </button>
          )}
        </div>
      </div>
      
      {showReply && review.replyText && (
        <div className="mt-3 bg-gray-50 p-3 rounded-md">
          <div className="flex items-center mb-2">
            <div className="h-6 w-6 rounded-full bg-blue-500 text-white flex items-center justify-center">
              <span className="text-xs font-medium">LP</span>
            </div>
            <div className="ml-2">
              <p className="text-sm font-medium">Brand ABC Support</p>
              <p className="text-xs text-gray-500">{formatDate(review.replyDate)}</p>
            </div>
          </div>
          <p className="text-sm text-gray-700">{review.replyText}</p>
        </div>
      )}
    </div>
  );
};

export default ReviewCard;